// Thin wrapper around the PostHog snippet already loaded globally in
// public/index.html (window.posthog). No new analytics dependency — we
// just call the existing infrastructure. Every call is best-effort: a
// missing/blocked posthog (ad blockers, dev environment) must never break
// the app.

export function trackEvent(name, properties = {}) {
  try {
    if (typeof window !== 'undefined' && window.posthog?.capture) {
      window.posthog.capture(name, properties);
    }
  } catch (_) { /* analytics should never break the app */ }
}

// Ties subsequent events (including anonymous pre-signup activity PostHog
// already captured) to this user, so returning-user / source reports work.
export function identifyUser(user) {
  try {
    if (typeof window !== 'undefined' && window.posthog?.identify && user?.user_id) {
      window.posthog.identify(user.user_id, { email: user.email, name: user.name });
    }
  } catch (_) { /* analytics should never break the app */ }
}
